import React from 'react';
import { Ellipsis } from '../ellipsis';

const EllipsisShowcase = () => (
  <React.Fragment>
    <h3>Hover the text</h3>
    <h4>Fixed parent width</h4>
    <div style={{ width: '50px' }}>
      <Ellipsis>
          Some very very long text here
      </Ellipsis>
    </div>
    <h4>Fixed predecessor width</h4>
    <div style={{ maxWidth: '200px' }}>
      <div style={{ width: '100%' }}>
        <Ellipsis>
          Some very very long text here
        </Ellipsis>
      </div>
    </div>
    <h4>No tooltip</h4>
    <div style={{ maxWidth: '200px' }}>
      <div style={{ width: '100%' }}>
        <Ellipsis
          showTooltip={false}
        >
          I have no tooltip, so I keep my mystery
        </Ellipsis>
      </div>
    </div>
    <h4>Width is explicitly passed to Ellipsis</h4>
    <Ellipsis
      width={50}
    >
      Some very long text here again!
    </Ellipsis>
  </React.Fragment>
);

export default EllipsisShowcase;
